export default {
    methods: {
        insertTextAtCursor(refName, currentValue, text, updateValue) {
            const value = currentValue ?? '';
            const input = this.$refs[refName]?.$el?.querySelector('input');
            if (!input || input.selectionStart == null || input.selectionEnd == null) {
                updateValue(value + text);
                return;
            }

            const start = input.selectionStart;
            const end = input.selectionEnd;
            const nextValue = value.slice(0, start) + text + value.slice(end);
            updateValue(nextValue);

            this.$nextTick(() => {
                input.focus();
                const cursor = start + text.length;
                input.setSelectionRange(cursor, cursor);
            });
        },
    },
};
